import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import { PORTAL_USERS_QUERY } from 'src/components/Pages/Commissions/graphql';
import { Field } from 'react-final-form';


function PortalUsersSelect({ operatorId }) {
    const variables = {
        operatorId
    };
    return (
        <Field
            name="portalUserId"
            component="select"
            className="form-control form-control-alternative"
        >
            <option value="">Todos</option>
            <option key="Nenhum" value="Nenhum">Nenhum</option>
            <Query query={PORTAL_USERS_QUERY} variables={variables}>
                {({ loading, error, data }) => {
                    if (loading || error) return <Fragment />;
                    const { portalUsers } = data;
                    const options = portalUsers.map(portalUser => (
                        <option
                            key={portalUser.id}
                            value={portalUser.id}
                        >
                          {portalUser.user.name ? portalUser.user.name : ''}
                            -
                          {portalUser.user.document}
                        </option>
                    ));
                    return options;
                }}
            </Query>
        </Field>
    );
}

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId
});

export default connect(mapStateToProps)(PortalUsersSelect);



// WEBPACK FOOTER //
// ./src/components/Pages/Commissions/Filters/PortalUsersSelect.js